import React from 'react';

import BlueStarBullet from '../../../../../assets/svg-components/growth/blue_star_bullet.svg';
import { Link } from '../../../../../components/link/link';
import { Text } from '../../../../../components/text/text';
import { Translate } from '../../../../../components/translate';

interface PresentationalLinkProps {
  href: string;
  label: string;
}

const PresentationalLink: React.FC<PresentationalLinkProps> = ({ href, label }) => {
  return (
    <span className="rc-video-card__link">
      <BlueStarBullet width="16" height="16" />
      <Link href={href} target="_blank" align="center" decoration="dotted-on-hover">
        <Text size="large" weight="bold">
          <Translate id={label} />
        </Text>
      </Link>

      <BlueStarBullet width="16" height="16" />
    </span>
  );
};

export default PresentationalLink;
